module.exports = __webpack_public_path__ + "img/NZ.b14c3467.svg";